<template>
  <div class="w-full">
    <div v-if="establecimientoActual" class="bg-white  overflow-hidden pt-16 pl-5">
          <!-- <div class="text-right">
       <p class="mt-1 w-full text-sm leading-5 font-bold text-red-600 px-4 sm:px-6">
     {{establecimientoActual.IDFORMULARIO}}
    </p>
    </div> -->
      <div class="border  bg-white shadow-xl rounded-lg ">
    <div class="px-5 py-5">
      <h3 class=" py-5 text-gray-800  text-2xl xl:text-4xl font-bold tracking-tighter leading-tight uppercase ">
      {{establecimientoActual.NOMBRE}}
    </h3>
    <p class="pt-1 px-1 w-full text-lg leading-6 font-base text-gray-600">
     {{establecimientoActual.DESCRIPCION}}
    </p>
    </div>
  <div class="px-4 pt-1 pb-10 border-b border-gray-300 flex flex-col flex-col-reverse w-full mx-auto ">

    <div class="flex py-5">
        <div class="flex flex-col justify-center">
          <div class="block">
          <p class="mt-1 max-w-2xl text-lg leading-5 font-semibold text-gray-800">
          {{establecimientoActual.DIRECCION}}
          </p>
          <p class="mt-1 max-w-2xl text-base leading-5 font-base text-gray-600">
          {{establecimientoActual.EMAIL}}
          </p>
          <p class="mt-1 max-w-2xl text-base leading-5 font-base text-gray-600">
          {{establecimientoActual.TELEFONO}}
          </p>
          <p class="mt-1 max-w-2xl text-base leading-5 font-base text-gray-600">
          {{establecimientoActual.POBLACION}}
          </p>            
          </div>
        </div>


    </div>
    <div v-if="establecimientoActual.URLIMAGEN" :style="`background-image:url('${establecimientoActual.URLIMAGEN}')`" class=" w-full h-64 lg:h-96 bg-top bg-no-repeat bg-cover">

    </div>
  </div>        
      </div>
  <!-- <div class="w-full w-auto min-h-full">


  </div> -->
  <!-- <div class="hidden">
    <dl>
      <div class="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
        <dt class="text-sm leading-5 font-medium text-gray-500">
         {{establecimientoActual.DIRECCION}}
        </dt>
        <dd class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2">
          Margot Foster
        </dd>
      </div>
      <div class="bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
        <dt class="text-sm leading-5 font-medium text-gray-500">
          Application for
        </dt>
        <dd class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2">
          Backend Developer
        </dd>
      </div>
      <div class="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
        <dt class="text-sm leading-5 font-medium text-gray-500">
          Email address
        </dt>
        <dd class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2">
          margotfoster@example.com
        </dd>
      </div>
      <div class="bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
        <dt class="text-sm leading-5 font-medium text-gray-500">
          Salary expectation
        </dt>
        <dd class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2">
          $120,000
        </dd>
      </div>
      <div class="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
        <dt class="text-sm leading-5 font-medium text-gray-500">
          About
        </dt>
        <dd class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2">
          Fugiat ipsum ipsum deserunt culpa aute sint do nostrud anim incididunt cillum culpa consequat. Excepteur qui ipsum aliquip consequat sint. Sit id mollit nulla mollit nostrud in ea officia proident. Irure nostrud pariatur mollit ad adipisicing reprehenderit deserunt qui eu.
        </dd>
      </div>
      <div class="bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
        <dt class="text-sm leading-5 font-medium text-gray-500">
          Adjuntos
        </dt>
        <dd class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2">
          <ul class="border border-gray-200 rounded-md">
            <li class="pl-3 pr-4 py-3 flex items-center justify-between text-sm leading-5">
              <div class="w-0 flex-1 flex items-center">
                <svg class="flex-shrink-0 h-5 w-5 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                  <path fill-rule="evenodd" d="M8 4a3 3 0 00-3 3v4a5 5 0 0010 0V7a1 1 0 112 0v4a7 7 0 11-14 0V7a5 5 0 0110 0v4a3 3 0 11-6 0V7a1 1 0 012 0v4a1 1 0 102 0V7a3 3 0 00-3-3z" clip-rule="evenodd"/>
                </svg>
                <span class="ml-2 flex-1 w-0 truncate">
                  DNI
                </span>
              </div>
              <div class="ml-4 flex-shrink-0">
                <a :href="establecimientoActual.URLDNI" targe="_blank" class="font-medium text-indigo-600 hover:text-indigo-500 transition duration-150 ease-in-out">
                  Descargar
                </a>
              </div>
            </li>
            <li class="border-t border-gray-200 pl-3 pr-4 py-3 flex items-center justify-between text-sm leading-5">
              <div class="w-0 flex-1 flex items-center">
                <svg class="flex-shrink-0 h-5 w-5 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                  <path fill-rule="evenodd" d="M8 4a3 3 0 00-3 3v4a5 5 0 0010 0V7a1 1 0 112 0v4a7 7 0 11-14 0V7a5 5 0 0110 0v4a3 3 0 11-6 0V7a1 1 0 012 0v4a1 1 0 102 0V7a3 3 0 00-3-3z" clip-rule="evenodd"/>
                </svg>
                <span class="ml-2 flex-1 w-0 truncate">
                  Certificado
                </span>
              </div>
              <div class="ml-4 flex-shrink-0">
                <a :href="establecimientoActual.URLCERTIFICADO" targe="_blank" class="font-medium text-indigo-600 hover:text-indigo-500 transition duration-150 ease-in-out">
                  Descargar
                </a>
              </div>
            </li>
            <li class="border-t border-gray-200 pl-3 pr-4 py-3 flex items-center justify-between text-sm leading-5">
              <div class="w-0 flex-1 flex items-center">
                <svg class="flex-shrink-0 h-5 w-5 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                  <path fill-rule="evenodd" d="M8 4a3 3 0 00-3 3v4a5 5 0 0010 0V7a1 1 0 112 0v4a7 7 0 11-14 0V7a5 5 0 0110 0v4a3 3 0 11-6 0V7a1 1 0 012 0v4a1 1 0 102 0V7a3 3 0 00-3-3z" clip-rule="evenodd"/>
                </svg>
                <span class="ml-2 flex-1 w-0 truncate">
                  IAE
                </span>
              </div>
              <div class="ml-4 flex-shrink-0">
                <a :href="establecimientoActual.URLIAE" targe="_blank" class="font-medium text-indigo-600 hover:text-indigo-500 transition duration-150 ease-in-out">
                  Descargar
                </a>
              </div>
            </li>
          </ul>
        </dd>
      </div>
    </dl>
  </div> -->
</div>
<!-- <pre>
  {{establecimientoActual}}
</pre> -->
  </div>
</template>
<script>
// const moment = require("moment");
// moment.locale("es");

export default {
  props: ['establecimientoActual'],
  data(){
    return {
      campos: [
  "PERSONA_CONTACTO",
  "CARGO",

 
  "WEB",
  // "FECHAMODIFICACION",

 
  "ID",
  "NOMBRE_ASOCIACION",
  "EMAIL",

  
  "NUMERO_EMPLEADOS",
  "PROVINCIA",
  "IDGOOGLE",
  "NOMBRE",
  "LNG",
  "RAZON_SOCIAL",
  "TELEFONO",
  "IAE",
  "IDORIGEN",
  "IBAN",
  "DIRECCION_GOOGLE",
  "IDFORMULARIO",
  "LAT",
  "DIRECCION",
  "CIF",
  "VALIDADO",
  "CODIGOPROCEDENCIA",
  "PAIS",
  "URLIMAGEN",
  "SECTOR_ACTIVIDAD",
  "CP",
  "URLDNI"
]
    }
  },
  methods: {
    getFecha(valor){
      // return moment(valor.FECHAALTA, "YYYYMMDDhhmmss").format('LLL')
      return 
    }
  }
  // computed: {
  //   establecimientoActual(){
  //     return this.$store.state.establecimientoActual
  //   }
  // }
}
</script>